import type { ReactNode } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router";
import { toaster } from "@/app";
import { authClient } from "@/lib/auth-client";

export function RequireRoot({ children }: { children: ReactNode }) {
  const session = authClient.useSession();

  const isRoot = session.data?.user?.role === "root";

  useEffect(() => {
    if (session.data && !isRoot) {
      toaster.create({
        title: "Page inaccessible",
        description:
          "Cette page est réservée aux administrateurs ChantierCarré. Retour à votre page d'accueil.",
        type: "error",
      });
    }
  }, [session.data, isRoot]);

  if (!session.data) {
    return null;
  }

  if (!isRoot) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
